var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[(_vm.site)?_c('site-form',{attrs:{"initial-site":_vm.site}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }